import { z } from "zod";

const ChargePropertiesSchema = z.object({
  amount: z.string().optional(),
  free_units: z.number().optional(),
  package_size: z.number().optional()
});
export const ChargeSchema = z.object({
  lago_id: z.string(),
  lago_billable_metric_id: z.string(),
  billable_metric_code: z.string(),
  created_at: z.string(),
  charge_model: z.enum([
    "standard",
    "graduated",
    "graduated_percentage",
    "package",
    "percentage",
    "volume",
    "dynamic"
  ]),

  properties: z.optional(ChargePropertiesSchema)
});

export const ChargesSchema = z.array(ChargeSchema);
export type Charge = z.infer<typeof ChargeSchema>;
export type Charges = z.infer<typeof ChargesSchema>;
